import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.css";
import {
  Switch,
  Route,
  HashRouter,
} from "react-router-dom";
import Home from "../../pages/Home";
import Faq from "../../pages/Faq";

import Header from "../commons/header";
import { GlobalStyle } from "./styled";
import Medios from "../../pages/Medios";

class App extends Component {
  constructor() {
    super();
    this.state = {
      showOverlay: true,
    };
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    this.setState({ showOverlay: false });
  }

  render() {
    return (
      <>
        <GlobalStyle />
          <HashRouter>
              <GlobalStyle />
              <Switch>
                <Route path="/" exact component={Home} />
                <Route
                  path="/preguntas-frecuentes"
                  exact
                  component={Faq}
                />
                <Route
                  path="/latamchequea-enmedios"
                  exact
                  component={Medios}
                />
              </Switch>
          </HashRouter>
      </>
    );
  }
}

export default App;
